import { attr, hasMany } from 'spraypaint';
import BaseApplicationRecord from './ApplicationRecord';

const Supplier = BaseApplicationRecord.extend({
  attrs: {
    code: attr(),
    name: attr(),
    primary_contact_first_name: attr(),
    primary_contact_last_name: attr(),
    primary_contact_email: attr(),
    primary_contact_phone: attr(),
    email_addresses_for_forecasts: attr({ type: Array }),
    lead_time_schedules: hasMany({ type: 'suppliers-lead_time_schedules', persist: true }),
  },
  static: {
    endpoint: '/suppliers',
    jsonapiType: 'suppliers-suppliers',
  },
});

export default Supplier;
